<section class="h-full flex flex-col gap-2 z-0 relative  p-2 lg:pl-0">

    <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">
        <div class="flex gap-2">
          <button routerLink="add" class="btn btn-secondary">Add</button>
        </div>
        <div>
            <div *ngIf="filterCustomerList">
                <h1 class="text-xs text-nowrap text-left">
                    Showing {{(50 * currentPage) - (filterCustomerList.length != 50?
                    (50
                    -filterCustomerList.length) : 0) }} of {{totalResults }} entries
                    <!-- Showing {{ filteredUsersList.length }} of {{ filteredUsersList.length }} entries -->
                </h1>
            </div>
        </div>
        <div class="flex flex-col gap-4 sm:flex-row sm:gap-2">
            <div class="flex gap-2">
                <div class="relative">
                    <input type="text" [(ngModel)]="search" (input)="onSearchInput()" required placeholder="Search.." class="pl-8" />
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="absolute left-2 top-1/2 transform -translate-y-1/2 size-5">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                    </svg>
                </div>
                <div>
                    <select class="w-full sm:w-44" [(ngModel)]="selectedCompanyId" (ngModelChange)="filterCustomers()">
                        <option [ngValue]="null">Select Company</option>
                        <option *ngFor="let company of companies" [ngValue]="company.id">{{ company.CompanyName |
                            capitalize }}</option>
                    </select>
                </div>
            </div>
        </div>
    </div>

    <div
        class="h-full overflow-hidden p-2 flex flex-col rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10">
        <div class="h-full w-full overflow-hidden rounded-md ring-1 ring-zinc-950/10 dark:ring-white/10">
            <div class="flow-root h-full overflow-y-auto">
                <div class="-my-2">
                    <div class="inline-block min-w-full py-2 align-middle">
                        <table class="min-w-full border-separate border-spacing-0">
                            <thead>
                                <tr>
                                    <!-- # -->
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        #
                                    </th>

                                    <!-- Actions -->
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Actions
                                    </th>


                                    <!-- Display Name -->
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Display Name
                                    </th>

                                    <!-- Display Name -->
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Reference
                                    </th>

                                    <!-- Email -->
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Email
                                    </th>

                                    <!-- Email -->
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        QB ID
                                    </th>
                                    

                                    <!-- Phone -->
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Phone
                                    </th>

                                    <!-- Address -->

                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Address
                                    </th>

                                    <!-- Fully Qualified Name -->
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Fully Qualified Name
                                    </th>

                                    <!-- Company Name -->
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Company Name
                                    </th>

                                    <!-- Company Name -->
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        QB Status
                                    </th>

                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Status
                                    </th>



                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let customer of (filterCustomerList | paginate: { itemsPerPage:numberOfRecords, currentPage: currentPage, totalItems:totalResults}); let i=index"
                                    class="hover:bg-gray-950/5 dark:hover:bg-white/10">


                                    <!-- SR -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap ">
                                        {{i+1}}
                                    </td>

                                    <!-- Actions -->

                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <div class="flex gap-2 items-center">
                        <div class="cursor-pointer" (click)="opendetailModal(customer)">
                            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path class="ng-tns-c14-5" d="M12 15a3 3 0 100-6 3 3 0 000 6z">
                                </path>
                                <path class="ng-tns-c14-5" clip-rule="evenodd"
                                                        d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 010-1.113zM17.25 12a5.25 5.25 0 11-10.5 0 5.25 5.25 0 0110.5 0z"
                                                        fill-rule="evenodd">
                                                    </path>
                                                </svg>
                                            </div>

                                            <button routerLink="{{customer.id}}/edit"
                                                class="hover:text-zinc-950 dark:hover:text-white text-zinc-500 dark:text-zinc-400">
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                    stroke-width="1.5" stroke="currentColor" class="size-5">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                                                </svg>
                                            </button>

                                            <div *ngIf="customer.company?.CompanyName" class="inline-flex relative">
                                                <a href="javascript:void(0)" (click)="showActionButtons(customer.id)"
                                                    class="hover:text-zinc-950 dark:hover:text-white text-zinc-500 dark:text-zinc-400">
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                        stroke-width="1.5" stroke="currentColor" class="size-5">
                                                        <path stroke-linecap="round" stroke-linejoin="round"
                                                            d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z" />
                                                    </svg>
                                                </a>
                                                <div (outsideClick)="closeActionMenu($event)" outside-click
                                                    *ngIf="selectedDropdownId === customer.id && toggleActionButtons"
                                                    class="action-menu"
                                                    role="menu" aria-orientation="vertical" aria-labelledby="menu-button"
                                                    tabindex="-1">
                                                    <app-action-dropdown-buttons
                                                        class="divide-y divide-zinc-950/10 dark:divide-white/10"
                                                        [source]="'customer'" [customer]="customer"
                                                        (pullFrom)="onSyncCustomer(customer, 'pull')"
                                                        (pushTo)="onSyncCustomer(customer, 'push')">
                                                    </app-action-dropdown-buttons>
                                                </div>
                                            </div>
                                        </div>
                                    </td>

                                    <!-- name -->

                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap ">
                                        {{customer.DisplayName}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap max-w-[200px] overflow-hidden">
                                        <div class="flex flex-col gap-0.5 leading-tight">
                                            <!-- Customer Name -->
                                            <span class="block max-w-[200px] truncate" [title]="customer.reference?.name || ''">
                                                {{ customer.reference?.name || 'N/A'}}
                                            </span>

                                            <!-- Customer ID -->
                                            <span *ngIf="customer.reference && customer.reference.id"
                                                class="text-[12px] text-blue-400 bg-blue-50 px py-0.5 rounded-md w-fit font-mono tracking-wide">
                                                {{ (customer.reference?.id).slice(0, 8) }}
                                            </span>
                                        </div>
                                    </td>

                                    <!-- email -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap ">
                                        {{customer?.PrimaryEmailAddr?.Address}}
                                    </td>

                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{customer.Id ? customer.Id : 'N/A'}}
                                    </td>

                                    <!-- phone -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap ">
                                        {{customer?.PrimaryPhone?.FreeFormNumber}}
                                    </td>

                                    <!-- address -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{customer?.BillAddr?.Line1}}
                                    </td>

                                    <!-- name -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{customer.FullyQualifiedName}}
                                    </td>

                                    <!-- company name -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <div>
                                            {{customer.company?.CompanyName}}
                                        </div>
                                    </td>

                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <span [ngClass]="customer.Active ? 'badge-primary' : 'badge-danger'">
                                            {{ customer.Active ? 'Active' : 'InActive' }}
                                        </span>
                                    </td>

                                    <!-- company name -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <span class="badge-primary">{{(customer.status | capitalize) || 'N/A'}}</span>
                                    </td>



                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex justify-end">
            <pagination-controls (pageChange)="onPageChange($event)" class="pagination-controls"></pagination-controls>
        </div>
    </div>
</section>

<app-customer-detail-modal *ngIf="customerDetail" [customerDetail]="customerDetail"
    (closeModal)="customerDetail = null"> </app-customer-detail-modal>